(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn();

    } else {
        RivalIQ.module('metrics.new.enums', function (enums) {
            enums.DimensionReducerIds = exportFn();
        });

    }

    function exportFn() {
        return {
            average: 'average',
            median: 'median',
            averageRate: 'averageRate',
            aggregateLift: 'aggregateLift',
            averagePerDay: 'averagePerDay',
            averagePerWeek: 'averagePerWeek',
            sum: 'sum',
            latestNonNull: 'latestNonNull',
            distinctCount: 'distinctCount',
            averagePerCompanyPerPeriod: 'averagePerCompanyPerPeriod',
            companiesAverage: 'companiesAverage',
            companiesMedian: 'companiesMedian',
            companiesSum: 'companiesSum'
        };
    }
})();
